<template>
  <!-- can-cancel = ['escape', 'x', 'outside'] si se quiere que cierre  por cualqiera de esos [] caso contrario -->
  <b-modal :active.sync="isModalActive" :width="480" scroll="keep" :can-cancel="[]">
    <b-loading :is-full-page="false" v-model="isLoading" :can-cancel="false"></b-loading>
    <div class="rounded-lg shadow-xl bg-white overflow-hidden border border-gray-200 border-[#E4E6EB]">
      <!-- HEADER sin fondo gris -->
      <header class="flex justify-between items-start flex-wrap gap-2 text-sm font-medium text-gray-800 px-4 py-4 border-b border-[#E4E6EB] uppercase tracking-wide">
        <div class="flex-1 min-w-0">
          <h2 class="break-words whitespace-normal">
            {{ data && data.id ? $t('edit_status') : $t('add_status') }}
          </h2>
        </div>
        <div class="flex-shrink-0">
        </div>
      </header>

      <div class="px-4 py-4 space-y-4 bg-white">
        <status-form ref="refStatusForm"
          :status="data"
          :colorpickerInline="true"
          :show-actions="false"
          :show-header="false"
          :weighting-criteria="weightingCriteria"
          :visibility="visibility"
        />
      </div>

      <footer class="px-4 py-4 border-t border-[#E4E6EB] bg-white">
        <div class="w-full flex justify-between items-center">
          <div class="flex items-center">
            <v-button v-if="!processingData" color="grey" icon="door-closed" size="is-small" @click="isModalActive = false">{{ $t('close') }}</v-button>
          </div>
          <div class="flex items-center gap-2">
            <v-button v-if="!processingData" @click="addItem()" icon="save" size="is-small">{{ $t('save') }}</v-button>
            <v-button-processing v-if="processingData" />
          </div>
        </div>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import StatusForm from './status-form.vue';

export default {
  name: "StatusFormModal",

  components: {
    StatusForm
  },

  props: {
  },

  data() {
    return {
      isModalActive: false,
      isLoading: false,
      processingData: false,

      data: null,
      weightingCriteria: null, // Se puede usar para pasar criterios de ponderación si es necesario
      visibility: null, // Se puede usar para pasar la visibilidad si es necesario
    }
  },

  computed: {

  },

  created() {
  },

  methods: {
    async addItem() {
      // El modal ya no persiste. Arma el payload y emite hacia arriba.
      // El padre (statuses.vue) llama al manager via :api.
      const payload = Object.assign({}, this.data, this.$refs.refStatusForm.getData());
      this.$emit('epc-status-add', payload);
      this.hide();
    },

    show(data, visibility, weightingCriteria = null) {
      this.data = data;
      this.weightingCriteria= weightingCriteria; // Asignar el criterio de ponderación si se proporciona
      this.visibility = visibility;
      this.isModalActive = true;
    },

    hide() {
      this.data = null;
      this.weightingCriteria = null; // Reiniciar si es necesario
      this.visibility = null; // Reiniciar la visibilidad si es necesario

      this.isModalActive = false;

    }
  }
};
</script>
<style scoped>
/* Oculta los botones para aumentar los inputs numéricos */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  /* display: none; <- Crashes Chrome on hover */
  -webkit-appearance: none;
  margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}

input[type="number"] {
  -moz-appearance: textfield; /* Firefox */
  appearance: textfield; /* Estándar */
}
</style>
